import { NetUtil } from './framework/utils/NetUtil';
import { audioManager } from './objects/AudioManager';
import { ObjectBase } from './framework/ObjectBase';
import { FW } from './framework/Framework';

export class AppBase extends PIXI.utils.EventEmitter {

    private _mask:PIXI.Graphics;

    constructor() {
        super();

        window.onblur = () => {
            audioManager.forceStopAll();
        };
        
    }


    protected reset(): void {
        if(this._mask && this._mask.parent) {
            this._mask.parent.removeChild(this._mask);
        }

        FW.incidentsManager.reset();
        ObjectBase.cleanAll();
        FW.physics.reset();
        FW.root.removeChildren();

        if(this._mask == null) {
            this._mask = new PIXI.Graphics();
            this._mask.beginFill(0);
            this._mask.drawRect(0, 0, FW.stageWidth, FW.stageHeight);
            this._mask.endFill();
        }
        FW.root.addChild(this._mask);
        FW.root.mask = this._mask;
    }

    public static get debug(): boolean {
        return NetUtil.getQueryStringValue('debug') == 'brad';
    }
}



// WEBPACK FOOTER //
// ./src/app.base.ts